export default class UpdateMarkerModel {
    assetId = null;
    scanId = null;
    id = null;
    transform = null;
    inspectionAreaId = null;
    status = null;
    eTag = null;

    constructor(id, assetId, transform, status, inspectionAreaId = null, eTag, scanId = null){
        this.id = id;
        this.assetId = assetId;
        this.scanId = scanId;
        this.transform = transform;
        this.status = status;
        this.inspectionAreaId = inspectionAreaId;
        this.eTag = eTag;
    }
}